(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__bagifiCardSwatchesInit) return;
    window.__bagifiCardSwatchesInit = true;

    function activateSwatch(swatch) {
      var wrapper = swatch.closest('.card-wrapper');
      if (!wrapper) return;

      var group = swatch.closest('.card-color-swatches');
      if (group) {
        group.querySelectorAll('.card-color-swatch--active').forEach(function (el) {
          el.classList.remove('card-color-swatch--active');
        });
      }
      swatch.classList.add('card-color-swatch--active');

      var img = wrapper.querySelector('.card__main-image');
      var newSrc = swatch.getAttribute('data-swatch-image');
      if (img && newSrc) {
        var newSrcset = swatch.getAttribute('data-swatch-srcset');
        img.src = newSrc;
        if (newSrcset) img.srcset = newSrcset;
      }
    }

    document.addEventListener(
      'click',
      function (event) {
        var swatch = event.target.closest('.card-color-swatch');
        if (!swatch) return;
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }
        activateSwatch(swatch);
      },
      true
    );

    document.addEventListener(
      'mouseover',
      function (event) {
        var swatch = event.target.closest('.card-color-swatch');
        if (!swatch) return;
        activateSwatch(swatch);
      },
      { passive: true }
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
